import { AppModal } from '@/components/compose/app.modal';
import { VisitsHistoryView } from '../main/main-screen-views/visits.history.view';
import { useAppRouter } from '@/hooks/use.app.router';

export default function VisitsHistoryModal() {
  const { params } = useAppRouter();
  const userId = (params as any)?.userId;
  return (
    <AppModal title={'سوابق مشاوره'}>
      <VisitsHistoryView userId={userId as string} header={false} />
    </AppModal>
  );
}
